import {
  SUPPLIER_ORDER_ACTIVE_STATUS_VALUES,
  SUPPLIER_ORDER_LEGACY_STATUS_VALUES,
  SUPPLIER_ORDER_STATUS_VALUES,
  type SupplierOrderStatus,
} from '../../types/supplierOrder';

// UI aliases shared by the create wizard and detail page. The canonical
// frontend contract lives in types/supplierOrder.ts.
export const SUPPLIER_ORDER_STATUSES = SUPPLIER_ORDER_ACTIVE_STATUS_VALUES;
export const SUPPLIER_ORDER_LEGACY_STATUSES = SUPPLIER_ORDER_LEGACY_STATUS_VALUES;
export { SUPPLIER_ORDER_STATUS_VALUES };
export type {
  ActiveSupplierOrderStatus,
  SupplierOrderStatus,
} from '../../types/supplierOrder';

export const SUPPLIER_ORDER_PROGRESS_STATUSES: SupplierOrderStatus[] = [
  'DRAFT',
  'SENT',
  'CONFIRMED',
  'IN_PRODUCTION',
  'READY',
  'SHIPPED',
  'PARTIALLY_RECEIVED',
  'RECEIVED',
];

export const SUPPLIER_ORDER_STATUS_COLORS: Record<SupplierOrderStatus, string> = {
  DRAFT: 'default',
  SENT: 'processing',
  CONFIRMED: 'blue',
  IN_PRODUCTION: 'gold',
  PARTIALLY_READY: 'cyan',
  READY: 'cyan',
  SHIPPED: 'purple',
  PARTIALLY_RECEIVED: 'gold',
  RECEIVED: 'green',
  ON_HOLD: 'magenta',
  CANCELLED: 'red',
};

export const getSupplierOrderStatusColor = (status?: string | null): string => {
  if (!status || !SUPPLIER_ORDER_STATUS_VALUES.includes(status as SupplierOrderStatus)) {
    return 'default';
  }

  return SUPPLIER_ORDER_STATUS_COLORS[status as SupplierOrderStatus];
};
